export default {
      id: "accumulation-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#accumulation",
      toString: function () {
        return this.url;
      }
    }